import { render, staticRenderFns } from "./ChartingWorkspaceStage.vue?vue&type=template&id=b2eaef1e&scoped=true&"
import script from "./ChartingWorkspaceStage.vue?vue&type=script&lang=js&"
export * from "./ChartingWorkspaceStage.vue?vue&type=script&lang=js&"
import style0 from "./ChartingWorkspaceStage.vue?vue&type=style&index=0&id=b2eaef1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2eaef1e",
  null
  
)

export default component.exports